
import React, { useCallback, useMemo, useState } from 'react'

import { Popover } from 'antd-mobile'

import { DownOutline, GlobalOutline } from 'antd-mobile-icons'

import { setLanguageStore } from '../../utils/storage/language'
import { getDictData } from '../../model/tour'
import { dictDataStore, countriesStore } from '../../utils/storage/tour.store'
import { setDictData } from '../../utils/storage/tour'
import { getCurrLang } from '../../locales'

import './index.less'

const items = [
    { key: 'zh_CN', short: 'zh', text: '中文', icon: null },
    { key: 'en_US', short: 'en', text: 'EN', icon: null },
    { key: 'th_TH', short: 'th', text: 'ไทย', icon: null },
]

const SelectLanguage = ({ needNewDict = false }) => {
    const [currentLang, setCurrentLang] = useState(() => getCurrLang())

    const currentItem = useMemo(
        () => items.find(item => item.short === currentLang) || items[1],
        [currentLang]
    )

    const refreshDictAndReload = useCallback(
        async (selectedKey) => {
            setLanguageStore(selectedKey)
            dictDataStore.remove()
            countriesStore.remove()

            if (!needNewDict) {
                window.location.reload()
                return
            }

            try {
                const data = await getDictData({}, true)
                setDictData(data)
            } catch (error) {
                console.error('刷新字典数据失败', error)
            } finally {
                window.location.reload()
            }
        },
        [needNewDict]
    )

    const handleAction = useCallback(
        (action) => {
            setCurrentLang(action.short)
            refreshDictAndReload(action.key)
        },
        [refreshDictAndReload]
    )

    return (
        <div className="lan-container">
            <Popover.Menu
                actions={items}
                onAction={handleAction}
                placement="bottom-start"
                trigger="click"
            >
                <div className="jm-flex">
                    <GlobalOutline fontSize={18} />
                    <span style={{ fontSize: 14, fontWeight: 400 }}>{currentItem.text}</span>
                    <DownOutline style={{ verticalAlign: 'sub' }} />
                </div>
            </Popover.Menu>
        </div>
    )
}

export default SelectLanguage